// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__xOb5h","signatureButtonsRight":"ModalSign_signatureButtonsRight__3CFxX"};